import { render } from "./EmployeeStatus.vue?vue&type=template&id=c2be6fe6"
import script from "./EmployeeStatus.vue?vue&type=script&lang=js"
export * from "./EmployeeStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__